import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import DropdownSelect, { SelectType } from '../../components/DropdownSelect';
import AddMultiStoreModal from '../../components/modal/AddMultiStoreModal';
import StoreController, { CurrentStoreContext, StoreType } from '../../controller/StoreController';
import { AuthContext } from '../../navigation/AuthProvider';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import { APP_TYPE } from '../../utils/DataType';
import DashboardAddHotel from './DashboardAddHotel';
import DashboardNotification from './DashboardNotification';
import RequiredComponent from './DashboardRequired';

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userInfo } = useContext(AuthContext);
  const { currentStore, setCurrentStore } = useOutletContext<CurrentStoreContext>();

  const [visibleMultiStoreModal, setVisibleMultiStoreModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [multiStoreInfo, setMultiStoreInfo] = useState<SelectType[]>([currentStore]);
  const [entryData, setEntryData] = useState<any[]>([]);
  const selfJoinValue = userInfo.selfJoined ?? false;

  const selectStoreInfo = async (e: any) => {
    AsyncLocalStorage.setItem('ceo-currentStore', JSON.stringify(e));
    setCurrentStore(e);
  };
  const getStoreList = async () => {
    const userData = await AsyncLocalStorage.getItem('ceo-userData');
    let storeListTemp: SelectType[] = [];
    if (userData) {
      userData?.store_list?.map((item: StoreType, index: number) => {
        if (item.store_type === 1 || item.store_type === 4) {
          storeListTemp.push({
            key: index,
            value: item.store_id,
            name: item.store_name,
            label: item.store_name,
          });
        }
      });
      setMultiStoreInfo([...storeListTemp]);
    }
  };

  // 입점 필수 입력값 체크
  const getEntryStatus = async () => {
    if (currentStore) {
      setIsLoading(true);
      try {
        const oData = {
          app_type: APP_TYPE.KNOCKWEB,
          store_id: currentStore.value,
        };

        const response = await StoreController.getEntryStatus(oData);

        if (response.data.ok) {
          setEntryData(response.data.data);
        }
      } catch (err) {
        console.log('err-->', err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    console.log('useInfo', userInfo);
    getStoreList();

    if (!userInfo) {
      setTimeout(() => {
        navigate('/', { replace: true });
      }, 1);
    }
  }, [userInfo]);

  useEffect(() => {
    getEntryStatus();
  }, [currentStore]);

  return (
    <Style>
      <div className="rightContentWrap dashboard">
        <div className="header">
          <DropdownSelect
            options={multiStoreInfo}
            defaultValue={currentStore}
            onChangeValue={selectStoreInfo}
            icon={
              location.pathname.indexOf('/store/salemanager') !== -1
                ? undefined
                : 'ic_arrow_down_grey'
            }
          />
          <button onClick={() => setVisibleMultiStoreModal(true)}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus_black.svg`} alt="add" />
            <p>멀티매장 추가 등록하기</p>
          </button>
        </div>
        <div className="dashboardContentWrap">
          <div className="top">
            <div className="box">
              {!isLoading ? (
                <RequiredComponent entryData={entryData} selfJoinValue={selfJoinValue} />
              ) : null}
            </div>
          </div>
          <div className="bottom flexrow">
            <div className="box">
              <DashboardAddHotel defaultStoreInfo={currentStore} />
            </div>
            <div className="box">
              <DashboardNotification />
            </div>
          </div>
        </div>
      </div>
      <AddMultiStoreModal
        isVisible={visibleMultiStoreModal}
        setVisible={setVisibleMultiStoreModal}
      />
    </Style>
  );
};

export default Dashboard;

const Style = styled.div`
  /* 공통 */
  .flexrow {
    display: flex;
    align-items: center;
  }

  /* rightContentWrap */
  .rightContentWrap.dashboard {
    min-height: calc(100vh - 54px);
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
    border-radius: 6px;
    background: #e5e5e5;

    button {
      display: flex;
      align-items: center;
      padding: 9px 16px 8px 16px;
      border-radius: 4px;
      gap: 6px;
    }
    button:hover {
      background: #ddd;
    }
    p {
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }
  }
  .selector {
    width: 300px;
    border: none;
    background: #fefefe;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .selectList .selectItem.selected {
    background: #333;
  }

  /* dashboardContentWrap */
  .dashboardContentWrap {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .top {
    flex: 1;
  }
  .bottom {
    flex: 1;
    height: 100%;
    gap: 16px;
  }
  .box {
    flex: 1;
    height: 100%;
    min-height: 400px;
    padding: 8px;
    background: #fff;
    border-radius: 10px;
  }

  @media (max-width: 900px) {
    .rightContentWrap.dashboard {
      height: auto;
    }
    .header {
      margin: 0 8px;
    }
    .bottom {
      flex-direction: column;

      .box {
        width: 100%;
        min-height: auto;
      }
    }
  }
  @media (max-width: 500px) {
    .selector {
      width: 150px;
      font-size: 14px;
    }
    .header button {
      padding: 8px 12px;
      p {
        font-size: 12px;
      }
    }
  }
`;
